export class InventorySubType {
    constructor(json) {
        this.id = json.id;
        this.name = json.name;
    }
}
//# sourceMappingURL=InventorySubType.js.map